import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, Crown } from 'lucide-react';
import { PlatformAdminSidebar } from './AdminSidebar';

/**
 * Wraps a page's content with the Platform Admin sidebar. On desktop the
 * sidebar is a fixed left column; on mobile (<md) it collapses into a slide-in
 * drawer accessed via a hamburger button in a sticky top bar.
 */
const AdminChrome = ({ children, activeSection = '' }) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('zazu-admin-sidebar-collapsed') === 'true';
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  const persistCollapsed = (next) => {
    localStorage.setItem('zazu-admin-sidebar-collapsed', String(next));
    setCollapsed(next);
  };

  const handleSectionChange = (id) => {
    navigate(`/admin?section=${encodeURIComponent(id)}`);
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <PlatformAdminSidebar
        collapsed={collapsed}
        setCollapsed={persistCollapsed}
        activeSection={activeSection}
        setActiveSection={handleSectionChange}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Mobile top bar with hamburger */}
      <div
        className="md:hidden sticky top-0 z-30 bg-white border-b border-slate-200 h-14 flex items-center justify-between px-3 shadow-sm"
        data-testid="admin-mobile-topbar"
      >
        <button
          onClick={() => setMobileOpen(true)}
          className="p-2 -ml-2 rounded-md hover:bg-slate-100 text-slate-700"
          aria-label="Open menu"
          data-testid="admin-mobile-menu-btn"
        >
          <Menu className="w-6 h-6" />
        </button>
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-gradient-to-br from-teal-600 to-teal-700 rounded-lg flex items-center justify-center">
            <Crown className="w-4 h-4 text-white" />
          </div>
          <span className="font-semibold text-slate-900 text-sm">Zazu Admin</span>
        </div>
        <div className="w-9" />
      </div>

      <div className={`min-w-0 transition-all duration-300 ${collapsed ? 'md:pl-16' : 'md:pl-64'}`}>{children}</div>
    </div>
  );
};

export default AdminChrome;
